// Special case Intercompany Sale: nilai jual diisi oleh pengaju (cart & revisi)
export const isIntercompanySale = (item) => {
  if (!item || item.type_disposal !== 'special' || !item.type_special) return false
  return item.type_special.toLowerCase().replace(/_/g, ' ').trim() === 'intercompany sale'
}

export const isNilaiJualEmpty = (val) => {
  const empty = ['-', null, '', '.', undefined, '0', 0]
  return empty.includes(val)
}
